import styled from "styled-components";

export const MainContent = styled.div`
    display: flex;
    position: relative;
    padding-top:56px;
    padding-bottom:${props => props.padding_bottom ?? ''};
    width: ${props => props.width !== undefined ? props.width : '100%'};
    height: 100%;
    justify-content: center;
    background-color: ${props => props.theme.backgrounds.gray7} ;
    overflow: hidden;
    @media (max-width: 1550px){
        width: 100%; 
    }
`;


export const InnerSideBar = styled.div`
    background-color: ${props => props.theme.backgrounds.black};
    padding: 24px 8px 64px;
    background: #03134F;
    border-radius: 0px 0px 32px 0px;
    box-sizing: border-box;
    height: fit-content;
    gap:15px;
    min-width: 70px;
    display: flex;
    flex-direction: column;
`;

export const IconsInnerSideBar = styled.div`
    width: 54px;
    height: 82px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`

export const OrderListContainer = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${props => props.theme.backgrounds.gray7} ;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding-bottom: 20px;
`;

export const OrderFilter = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${props => props.theme.backgrounds.white};
`;

export const TaxesInfo = styled.div`
    display: flex;
    flex-direction: column;
    font-size: ${props => props.theme.font_size.small};
    border-bottom: ${props => props.theme.border.very_small};
    border-top: ${props => props.theme.border.very_small};
    margin-top: 10px;
    padding: 16px 0 16px 0;
    gap:${props => props.theme.gaps.more_less_big};
    p{
      color: ${({ theme }) => theme.colors.gray};
    }
`;

export const Taxes = styled.div`
   display: flex;
   width: 100%;
   justify-content: space-between;
   align-items:center;
    p{
      color: ${({ theme }) => theme.colors.gray};
    }
`;

export const TotalInfo = styled(Taxes)`
       align-items: center;
       font-size: ${props => props.theme.font_size.small};
       margin-top: 10px;
       margin-bottom: 0;
       
        p{
            font-weight: ${props => props.theme.font_weight.large};
        }
   
   `;

export const IconWrapper = styled.div`
    width: 20px;
    height:20px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const OrderFilterHeader = styled(OrderFilter)`
    padding:${props => props.theme.paddings.medium};
    font-size: ${props => props.theme.font_size.medium};
    line-height: ${props => props.theme.lines_height.large};
    color:${props => props.theme.colors.gray2};

    h1{
        font-weight: ${props => props.theme.font_weight.large};
        font-size: 24px;
        line-height: 30px;
        color: ${props => props.theme.colors.gray};
        margin-bottom: 12px;
    }

    .wrapperTitleDelivery{
        display:flex;
        width: 100%;
        justify-content: space-between;

        button{
            display:none;
        }
    }

    @media(max-width: 1550px){
        .wrapperTitleDelivery{
            button{
                display:inline;
                border-radius: ${props => props.theme.border_radius.small};
                background: ${props => props.theme.backgrounds.red2};
                width: 210px;
                height: 48px;
                font-weight: ${props => props.theme.font_weight.large};
                font-size: ${props => props.theme.font_size.small};
                line-height: ${props => props.theme.lines_height.medium};
                color: rgb(255, 255, 255);
            }
        }

    }
`;

export const OrderListTabWrapper = styled.div`
    width: 100%;
    display:flex;
    padding: 0 12px;
`;

export const OrderInProgress = styled.div`
    width: 156px;
    height: 52px;
    padding: ${props => props.theme.paddings.more_less_big};
    font-weight: ${props=> props.orderProgress ?  props.theme.font_weight.large : props.theme.font_weight.medium };
    font-size: ${props => props.theme.font_size.medium};    
    line-height: ${props => props.theme.lines_height.large};
    color: ${props => props.orderProgress ? props.theme.colors.gray : props.theme.colors.gray3 };
    border-bottom: ${props=> props.orderProgress ? `solid 2px ${props.theme.backgrounds.red2}` : 'none' };
    cursor:pointer;
`;

export const OrderEnded = styled(OrderInProgress)`
    font-weight: ${props=> props.orderFinished ? props.theme.font_weight.large : props.theme.font_weight.medium };
    color: ${props => props.orderFinished ? props.theme.colors.gray : props.theme.colors.gray3 };
    border-bottom: ${props=> props.orderFinished ? `solid 2px ${props.theme.backgrounds.red2}` : 'none' };
`;

export const InputWrapper = styled.div`
    width: 100%;
    display: flex;
    gap:${props => props.theme.gaps.more_less_big};
    margin-top:12px;
    align-items: center; 
`;

export const InputContainer = styled.div`
    background-color: ${props => props.theme.backgrounds.white};
    width: 100%;
    height: 100%;
    border-radius: ${props => props.theme.border_radius.small};
    display:flex;
    align-items: center;
    padding: 11px 12px;
    border: ${props => props.theme.border.very_small_gray5};

    .input{
        font-size:${props => props.theme.font_size.small};
        line-height: ${props => props.theme.lines_height.medium};
        width: 100%;
        text-decoration: none;
        color:${props => props.theme.colors.gray2};
    }
`;

export const SelectContainer = styled.div`
    width: 100%;
    max-width: 140px;
    min-width: 140px;
    position:relative;
    height:100%;
    background-color: ${props => props.theme.backgrounds.white};
    text-decoration: none;
    border-radius: ${props => props.theme.border_radius.small};
    display: flex;
    align-items:center;
    border: ${props => props.theme.border.very_small_gray5};
    padding: ${props => props.theme.paddings.medium};

    .icon-cursor{
        cursor: pointer;
    }
`;

export const OrderList = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${props => props.theme.backgrounds.gray7};
    flex-wrap: wrap;
    padding:${props => props.theme.paddings.large};
    align-items: center;

    .wrapper-order-list{
        max-width: 1100px;
        height: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
`;

export const DeliveryHomeDetailsHeader = styled.div`
    width:100%;
    display: flex;
    flex-direction: column;
    padding: 26px 24px 24px 24px;

    h2{
        font-weight: ${props => props.theme.font_weight.large};
        font-size: 24px;
        line-height: 29px;
        margin-bottom: ${props => props.theme.margins.medium};
        color: ${props => props.theme.colors.black}
    }

    h3{
        font-weight: ${props => props.theme.font_weight.large};
        font-size: ${props => props.theme.font_size.medium};
        line-height: ${props => props.theme.lines_height.large};
        color: ${props => props.theme.colors.black}
    }
`;

export const StablishmentStatusWrapper = styled.div`
    width: 100%;
    display: flex;
    gap:${props => props.theme.gaps.large};
    align-items: center;
    margin-bottom: 32px;

 
    @media(max-width: 900px) {
        flex-wrap: wrap;
    }
`; 

export const IconStablishmentStatus = styled.img`
    width: 20px;
    height:20px;
`; 

export const StablishmentStatus = styled.div`
    width: 221px;
    height: 90px;
    border:${props => props.theme.border.very_small_gray5} ;
    border-radius: ${props => props.theme.border_radius.medium};
    padding: 12px 16px;
    font-weight: ${props => props.theme.font_weight.large};
    font-size: ${props => props.theme.font_size.medium};
    line-height: ${props => props.theme.lines_height.medium};
    display: flex;
    flex-direction: column;
    gap:${props => props.theme.gaps.small};
    color:${props => props.theme.colors.black};
`;

export const Status = styled.div`
    width: 100%;
    display: flex;
    gap:${props => props.theme.gaps.small};
    align-items: center;
    font-weight: ${props => props.theme.font_weight.large};
    font-size: ${props => props.theme.font_size.medium};
    line-height: ${props => props.theme.lines_height.medium};
    

    p{
       color: ${props=>  props.statusStablishment ? '#50A773' : '#C51F2A' };
    }
`;

export const OpenCloseStablishment = styled.div`
    font-size: ${props => props.theme.font_size.medium};
    line-height: ${props => props.theme.lines_height.medium};
    text-decoration-line: underline;
    cursor: pointer;
    user-select: none;
    p {
        color: ${props=> !props.stablishmentStatus ? '#C51F2A': '#50A773'};
    }
`;

export const OrderInfoCardsContainer = styled.div`
    max-width: 100%;
    padding: ${props => props.theme.paddings.large};
    display:flex;
    flex-direction: column;
    gap:${props => props.theme.gaps.more_less_big};
    background: ${props => props.theme.backgrounds.white};
    margin-bottom: 250px;
    position: relative;
`;

export const CardsWrapper = styled.div`
    width:100%;
    max-width: 100%;
    /* max-height: 130px; */
    display: flex;
    gap:${props => props.theme.gaps.more_less_big};
    margin: ${props => props.margin ?? ''} ;

    @media(max-width: 1550px) {
        flex-wrap: wrap;
        height:auto;
    }
`;

export const Card = styled.div`
    flex-direction: column;
    width:100%;
    min-width:238px;
    /* height: 100%; */
    background-color: ${props=> props.background};
    border-radius: ${props => props.theme.border_radius.small};
    padding: 12px 24px;
    display: flex;
    justify-content: space-between;
    p{color:${props=> props.color};}
`;

export const CardContentLeft = styled.div`
    display: flex;
    gap:9px;
    justify-content:space-between;
    p{
        width: 60%;
    }
`;

export const CardContentRight = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .number{
        font-weight: ${props => props.theme.font_weight.large};
        font-size: 48px;
        line-height: 60px;
    }
`;

export const  IconOderCardInfo = styled.img`
    width:32px;
    height:32px;
`;

export const RedirectButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    padding: 0px 24px;
    gap: ${props => props.theme.gaps.small};
    width: 100%;
    max-width: ${props=>props.width};
    height: ${props=>props.height};
    border: ${props=>props.border};
    border-radius: ${props => props.theme.border_radius.small};
    background-color:${props=> props.background} ;
    font-weight: ${props => props.theme.font_weight.large};
    font-size: ${props => props.theme.font_size.medium};
    line-height: ${props => props.theme.lines_height.medium};
    color:${props=> props.color};
`;

export const StatusActionsButtons = styled.div`
    width: 100%;
    display: flex;
    text-decoration: none;
    justify-content: ${props=> props.justify};
    gap: 8px;
    a{
        text-decoration: none;
        width:${props=> props.justify === 'space-between'?'68px': 'inherit'};
    }
`;

export const ActionsButtons = styled.div`
    padding: 12px 12px 12px;
    position: ${props => props.position ?? 'absolute'};
    gap: ${props => props.theme.gaps.medium};
    bottom: 0;
    width: 100%;
    max-width: 100%;
    bottom:0;
    right: 0;
    height: ${props => props.height ?? '148px'};
    display:flex;
    flex-direction: column;
    justify-content: ${props=> props.align};
    background-color: ${props => props.theme.backgrounds.white};
    border-top: ${props => props.theme.border.very_small_gray5};

    .link{
        text-decoration: none;
        width: 100%;
    }

    @media(max-width:1550px){
        width: 100%;
        max-width: 560px;
    }

    @media(max-width:768px){
        width: 100%;
        max-width: 100%;
    }
`;  

export const Icons = styled.img`
    width:${props=>props.width};
    height:${props=>props.height};
`;

export const IconsAction = styled.img`
    width: 20px;
    height:20px;
    cursor: pointer;
`;

export const CheckBox = styled.div`
    width:20px;
    height:20px;
    min-width: 20px;
    display: flex;
    justify-content:center;
    align-items:center;
    border:${props=> props.selected ? props.theme.border.small_red2 : props.theme.border.very_small_gray5 };
    border-radius: 4px;
`;

export const SelectOptionsWrapper =styled.div`
    width: 150%;
    height: 158px;
    position: absolute;
    right: 0;
    top: 45px;
    padding-top: ${props => props.theme.paddings.more_less_big};
    min-height:158px;
    display: flex;
    flex-direction: column;
    background-color: ${props => props.theme.backgrounds.white};
    border-radius: ${props => props.theme.border_radius.medium};
    border: ${props => props.theme.border.very_small_gray5};
    overflow-y: auto;
    font-weight: ${props => props.theme.font_weight.medium};
    font-size: ${props => props.theme.font_size.small};
    line-height: ${props => props.theme.lines_height.medium};
    color: ${props => props.theme.colors.gray2};

`;

export const Options = styled.div`
    width: 100%;
    height: 42px;
    min-height: 42px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-weight: 400;
    font-size: ${props => props.theme.font_size.small} ;
    line-height: ${props => props.theme.lines_height.medium};
    color:${props=> props.selected ? props.theme.colors.red2: props.theme.colors.gray};
    padding: 0 16px 0px 16px;
    gap:${props => props.theme.gaps.small};
    cursor: pointer;


    :hover{
        background-color: ${props => props.theme.backgrounds.gray7};
    }
`;


export const FilterInfo = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap:${props => props.theme.border_radius.small};
    font-weight: ${props => props.theme.font_weight.medium};
    font-size: ${props => props.theme.font_size.small};
    line-height: ${props => props.theme.lines_height.medium};
    color: ${props => props.theme.colors.gray2};
`;

export const ModalOverlay = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(0, 0, 0, 0.3);
    z-index: 2004;
    display:flex;
    align-items: center;
    justify-content: center;
`;